const routes = {
  root: '/library',
}

export default routes
